import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const restaurantAPI = axios.create({
  baseURL: `${API_BASE_URL}/restaurant`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: { 'Content-Type': 'application/json' },
});

restaurantAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const restaurantService = {
  getConfig: async () => {
    const res = await restaurantAPI.get('/config');
    return res.data;
  },
  // Días habilitados en un rango
  getDays: async (from, to) => {
    const params = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const res = await restaurantAPI.get('/days', { params });
    return res.data;
  },
  // Slots disponibles (adentro/afuera) de una fecha
  getAvailability: async (date) => {
    const res = await restaurantAPI.get('/availability', { params: { date } });
    return res.data;
  },
  // Crear reserva (login)
  createReservation: async (data) => {
    const res = await restaurantAPI.post('/reservations', data);
    return res.data;
  },
  getMyReservations: async () => {
    const res = await restaurantAPI.get('/reservations/me');
    return res.data;
  },
  getReservation: async (id) => {
    const res = await restaurantAPI.get(`/reservations/${id}`);
    return res.data;
  },
  updateReservation: async (id, data) => {
    const res = await restaurantAPI.patch(`/reservations/${id}`, data);
    return res.data;
  },
};

export default restaurantService;
